const TWO = 2;

const formatValue = (zr, seriesModel, nameHeight, nameFontSize, newName, nameAlign = 'center') => {
  zr.style.text.match(/\{name\|(.+)\}\n/g);
  const nameStr = RegExp.$1;
  zr.style.text.match(/\{value\|(.+)\}/g);
  const valueStr = RegExp.$1;
  const containerRect = zr.dvParent.getBoundingRect();
  const distance = seriesModel.option.label.padding * TWO;
  const { fontSize, dvMinFontSize, dvLineHeight, dvValueFontDeviation } = seriesModel.option.label.rich.value;
  const { name } = seriesModel.option.label.rich;
  if (
    containerRect.height - distance - nameHeight - TWO >= dvMinFontSize * dvLineHeight &&
    containerRect.width - distance >= dvMinFontSize * valueStr.length
  ) {
    // 宽高能放下数值
    const minHeightFontSize = Math.floor((containerRect.height - distance - nameHeight) / dvLineHeight);
    const minWidthFontSize = Math.floor((containerRect.width - distance) / valueStr.length) + dvValueFontDeviation;
    const newFontSize = Math.max(Math.min(minHeightFontSize, minWidthFontSize, fontSize), dvMinFontSize);
    zr.attr({
      style: {
        y: (containerRect.height - distance - nameHeight - TWO - newFontSize * dvLineHeight) / TWO,
        text: zr.style.text.replace(nameStr, newName),
        rich: {
          name: {
            ...zr.style.rich.name,
            fontSize: nameFontSize,
            lineHeight: nameFontSize * name.dvLineHeight,
            align: nameAlign === 'center' ? nameAlign : undefined,
          },
          value: {
            ...zr.style.rich.value,
            fontSize: newFontSize,
            lineHeight: newFontSize * dvLineHeight,
          }
        }
      }
    });
  } else {
    // 放不下数值
    zr.attr({
      style: {
        y: (containerRect.height - distance - nameHeight) / TWO,
        text: zr.style.text.replace(nameStr, newName),
        rich: {
          name: {
            ...zr.style.rich.name,
            fontSize: nameFontSize,
            lineHeight: nameFontSize * name.dvLineHeight,
            align: nameAlign === 'center' ? nameAlign : undefined,
          },
          value: {
            ...zr.style.rich.value,
            opacity: 0,
          }
        }
      }
    });
  }
}

const formatName = (zr, seriesModel) => {
  zr.style.text.match(/\{name\|(.+)\}\n/g);
  const nameStr = RegExp.$1;
  const containerRect = zr.dvParent.getBoundingRect();
  const distance = seriesModel.option.label.padding * TWO;
  const { fontSize, dvMinFontSize, dvLineHeight } = seriesModel.option.label.rich.name;
  if (
    containerRect.width - distance < dvMinFontSize ||
    containerRect.height - distance < dvMinFontSize * dvLineHeight
  ) {
    // 宽高放不下一个字符，隐藏
    zr.hide();
    return;
  }
  if(
    containerRect.width - distance >= nameStr.length * fontSize &&
    containerRect.height - distance >= fontSize * dvLineHeight
  ) {
    // 单行居中不缩小不遮挡
    formatValue(zr, seriesModel, fontSize * dvLineHeight, fontSize, nameStr)
  } else if (
    containerRect.width - distance >= Math.ceil(nameStr.length / TWO) * fontSize &&
    containerRect.height - distance >= fontSize * dvLineHeight * TWO
  ) {
    // 两行居中不缩小不遮挡
    formatValue(
      zr, seriesModel, fontSize * dvLineHeight * TWO, fontSize,
      `${nameStr.substr(0, Math.floor(nameStr.length / TWO))}\n${nameStr.substr(Math.floor(nameStr.length / TWO))}`
    )
  } else if(
    containerRect.width - distance >= nameStr.length * dvMinFontSize &&
    containerRect.height - distance >= dvMinFontSize * dvLineHeight
  ) {
    // 单行缩小不遮挡
    const minWidthFontSize = Math.floor((containerRect.width - distance) / nameStr.length);
    const minHeightFontSize = Math.floor((containerRect.height - distance )/ dvLineHeight);
    const newFontSize = Math.min(minWidthFontSize, minHeightFontSize);
    formatValue(zr, seriesModel, newFontSize * dvLineHeight, newFontSize, nameStr)
  } else if(
    containerRect.width - distance >= Math.ceil(nameStr.length / TWO) * dvMinFontSize &&
    containerRect.height - distance >= dvMinFontSize * dvLineHeight * TWO
  ) {
    // 两行居中缩小不遮挡
    const minWidthFontSize = Math.floor((containerRect.width - distance) / Math.ceil(nameStr.length / TWO));
    const minHeightFontSize = Math.floor((containerRect.height - distance) / TWO / dvLineHeight);
    const newFontSize = Math.min(minWidthFontSize, minHeightFontSize);
    formatValue(
      zr, seriesModel, newFontSize * dvLineHeight * TWO, newFontSize,
      `${nameStr.substr(0, Math.floor(nameStr.length / TWO))}\n${nameStr.substr(Math.floor(nameStr.length / TWO))}`
    )
  } else if(containerRect.height - distance >= dvMinFontSize * dvLineHeight * TWO) {
    // 两行缩小遮挡
    formatValue(
      zr, seriesModel, dvMinFontSize * dvLineHeight * TWO, dvMinFontSize,
      `${nameStr.substr(0, Math.floor(nameStr.length / TWO))}\n${nameStr.substr(Math.floor(nameStr.length / TWO))}`,
      nameStr.length % TWO === 1 ? 'center' : 'left'
    )
  } else if(containerRect.height - distance >= dvMinFontSize * dvLineHeight) {
    // 单行缩小遮挡
    formatValue(zr, seriesModel, dvMinFontSize * dvLineHeight, dvMinFontSize, nameStr, 'left')
  } else {
    // 隐藏
  }
}

const eachLabel = (data, seriesModel) => {
  if (data._children) {
    data._children.forEach((item) => {
      eachLabel(item, seriesModel);
    });
  } else if(data._textContent) {
    const { padding } = seriesModel.option.label;
    data._textContent.getBoundingRect();
    const zr = data._textContent;
    zr.dvParent = data;
    const { width, height } = data.shape;
    zr.setClipPath(new data.constructor({
      shape: {
        x: -width / TWO + padding,
        y: -height / TWO,
        width: width - padding * TWO,
        height: height,
      }
    }));
    formatName(zr, seriesModel);
  }
};

const staticCenter = (group, seriesModel) => {
  if (seriesModel.option.data && seriesModel.option.data.length) {
    eachLabel(group, seriesModel);
  }
};

export default staticCenter;
